<template>
  <div>
    <v-card class="mb-12" height="50px" :style="{ 'box-shadow': '0 0 black' }">
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3 class="mb-5">Set Merchant</h3>
        <small>Pilih cara set merchant</small>
      </div>
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-select
          id="promoType"
          ref="promoType"
          outlined
          label="Merchant"
          v-model="promoType"
          @change="$v.promoType.$touch()"
          @blur="$v.promoType.$touch()"
          :error-messages="promoTypeErrors"
          :items="promoTypeList"
          :disabled="disableFormPromoType || disableForm"
          :loading="loading"
        />
      </v-col>

      <v-col v-if="showSelected" cols="12">
        <v-combobox
          id="merchants"
          ref="merchants"
          :search-input.sync="searchMerchant"
          v-model="merchants"
          :items="merchantList"
          hide-selected
          label="Merchant List"
          multiple
          persistent-hint
          small-chips
          outlined
          item-text="mid"
          :loading="loadingMerchant"
          return-object
          @change="$v.merchants.$touch()"
          @blur="$v.merchants.$touch()"
          :error-messages="merchantsErrors"
          hint="Search by MID"
          :disabled="disableForm"
        >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
              v-if="item == Object(item)"
              v-bind="attrs"
              color="primary"
              :input-value="selected"
              label
              small
            >
              <span class="pr-2">
                {{ item.merchant_name + ' - ' + item.mid }}
              </span>
              <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            {{ item.merchant_name + ' - ' + item.mid }}
          </template>
        </v-combobox>
      </v-col>
    </v-row>

    <v-row v-if="showBulk" align="center">
      <v-col md="5" cols="12">
        <v-file-input
          id="fileBulkMerchant"
          ref="fileBulkMerchant"
          label="Data Merchant (.xlsx)"
          placeholder="Select your files"
          :accept="validate.file_bulk_merchant.type.join()"
          persistent-hint
          outlined
          prepend-inner-icon="mdi-paperclip"
          prepend-icon=""
          v-model="fileBulkMerchant"
          @click="clearLastResult()"
          @focus="fileBulkMerchantFocus += 1"
          :error-messages="fileBulkMerchantErrors"
          @change="$v.fileBulkMerchant.$touch()"
          @blur="$v.fileBulkMerchant.$touch()"
          :loading="onUpload"
          :disabled="onUpload || disableForm"
        />
      </v-col>
      <v-col md="7" cols="12" class="pb-10">
        <v-btn
          small
          x-large
          color="success"
          @click="upload"
          class="ml-2 float-right mb-2"
          :loading="onUpload"
          :disabled="disableForm"
        >
          Upload
        </v-btn>
        <v-btn
          v-show="showOnlyEdit"
          small
          x-large
          @click="downloadMerchantPromo"
          class="ml-2 float-right mb-2"
          :loading="loadingMerchantPromo"
          :disabled="oldPromoType == 1"
        >
          <v-icon>mdi-file-excel</v-icon>
        </v-btn>
        <v-btn
          small
          x-large
          @click="downloadBaseTemplate"
          class="float-right mb-2"
          :disabled="disableForm"
        >
          Download Template
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="end">
        <v-btn
          small
          color="primary"
          dark
          @click="changeStep(2)"
          :loading="loading"
        >
          Lanjut
          <v-icon dark right> mdi-arrow-right </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import {
  dataPromoTypeList,
  scrollOptions,
  validations,
} from '../../../store/params';
import { date, showAlert } from '../../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    promoType: { required },
    merchants: {
      required() {
        return !(this.promoType == 3 && this.merchants.length <= 0);
      },
    },
    fileBulkMerchant: {
      required() {
        if (this.promoType == 2 && this.fileBulkMerchantFocus > 1) {
          return this.fileBulkMerchant != null;
        }
        return true;
      },
      fileType() {
        if (this.promoType == 2 && this.fileBulkMerchant != null) {
          return !!validations.file_bulk_merchant.type.includes(
            this.fileBulkMerchant.type.toLowerCase()
          );
        }
        return true;
      },
    },
  },
  data: () => ({
    loadingMerchant: false,
    downloadURL: '',
    loadingMerchantPromo: false,
    loadingDownloadFile: false,
    showSelected: false,
    showBulk: false,
    promoTypeList: dataPromoTypeList,
    searchMerchant: '',
    validate: validations,
    search: { mid: '' },
    fileBulkMerchant: null,
    fileBulkMerchantFocus: 0,
  }),
  mounted() {
    this.getMerchant();
    this.downloadTemplate();
  },
  watch: {
    promoType(val) {
      this.showSelected = false;
      this.showBulk = false;
      this.$store.commit('promo/setDataVariable', {
        variable: 'merchants',
        payload: [],
      });

      if (val == 3) {
        this.showSelected = true;
      } else if (val == 2) {
        this.showBulk = true;
      }
    },
    searchMerchant(val) {
      this.search.mid = val;
      this.getMerchant();
    },
  },
  computed: {
    disableForm() {
      return this.$store.state.promo.data?.disabled_form || false;
    },
    oldPromoType() {
      return this.$store.state.promo.data.old_promo_type;
    },
    disableFormPromoType() {
      return !!this.$route.params.id;
    },
    loading() {
      return this.$store.state.promo.loading;
    },
    onUpload() {
      return this.$store.state.promo.onUpload;
    },
    merchantList() {
      return this.$store.state.promo.merchantList;
    },

    fileBulkMerchantErrors() {
      const errors = [];
      if (!this.$v.fileBulkMerchant.$dirty) return errors;
      if (!this.$v.fileBulkMerchant.required)
        errors.push('File Merchant is required for upload');
      if (!this.$v.fileBulkMerchant.fileType)
        errors.push('Incorrect filetype Merchant File');
      return errors;
    },

    merchants: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'merchants',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.merchants;
      },
    },
    merchantsErrors() {
      const errors = [];
      if (!this.$v.merchants.$dirty) return errors;
      if (!this.$v.merchants.required) errors.push('Merchant is required');
      return errors;
    },

    promoType: {
      set(val) {
        this.$store.commit('promo/setDataVariable', {
          variable: 'promo_type',
          payload: val,
        });
      },
      get() {
        return this.$store.state.promo.data.promo_type;
      },
    },
    promoTypeErrors() {
      const errors = [];
      if (!this.$v.promoType.$dirty) return errors;
      if (!this.$v.promoType.required) errors.push('Jenis Promo is required');
      return errors;
    },

    id() {
      return this.$store.state.promo.data.id;
    },

    bulkId() {
      return this.$store.state.promo.data.bulk_id;
    },

    bulkUploadStatus() {
      return this.$store.state.promo.data.bulk_upload_status;
    },

    bulkValidate() {
      return this.promoType == 2
        ? (this.id && !this.bulkUploadStatus) || this.bulkId
        : true;
    },

    showOnlyEdit() {
      return this.$route.params?.id || false;
    },
  },
  methods: {
    downloadBaseTemplate() {
      window.location.href = this.downloadURL;
    },

    changeStep(val) {
      this.$v.fileBulkMerchant.$touch();
      this.$v.$touch();
      if (this.$v.$invalid && this.$route.params.id) {
        this.$store.commit('promo/setStep', val);
      } else if (!this.$v.$invalid && this.bulkValidate) {
        this.$store.commit('promo/setStep', val);
      } else if (!this.bulkValidate) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Data merchant must be uploaded !',
          'mdi-alert',
          'red'
        );
      } else {
        this.scrollToErrorInput();
      }
    },
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('promo/setFlashErrorMessage', '');
      this.$store
        .dispatch('promo/getMerchant', {
          date,
          sortBy: 'ID',
          search: this.search,
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },
    clearLastResult() {
      this.$store.commit('promo/clearLastResult');

      this.$store.commit('promo/setDataVariable', {
        variable: 'bulk_upload_status',
        payload: false,
      });

      this.$store.commit('promo/setDataVariable', {
        variable: 'bulk_id',
        payload: '',
      });
    },
    downloadTemplate() {
      this.$store.dispatch('promo/downloadTemplate', {}).then((response) => {
        this.downloadURL = response;
      });
    },
    downloadMerchantPromo() {
      this.loadingMerchantPromo = true;
      this.$store
        .dispatch('promo/downloadMerchanPromo', {
          date,
          promoId: this.$route.params.id,
        })
        .then((response) => {
          if (response) {
            window.location.href = response.data;
          }
        })
        .finally(() => {
          this.loadingMerchantPromo = false;
        });
    },
    upload() {
      this.$store.commit('promo/clearLastResult');
      this.fileBulkMerchantFocus = 2;
      this.$v.fileBulkMerchant.$touch();
      if (!this.$v.fileBulkMerchant.$error) {
        this.$store
          .dispatch('promo/bulkUpload', {
            file: this.fileBulkMerchant,
          })
          .then(() => {});
      }
    },

    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        const input = key;

        if (input.includes('$')) return;

        if (this.$v[input].$error) {
          this.$vuetify.goTo(`#${input}`, scrollOptions);
          isError = true;
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },
  },
};
</script>
